import { render, staticRenderFns } from "./SalesInvoiceViewDetails.vue?vue&type=template&id=2273bf38"
import script from "./SalesInvoiceViewDetails.vue?vue&type=script&lang=js"
export * from "./SalesInvoiceViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports